import { ProductStage } from '../types/common';
import { isApparelProduct } from './product';

export const removeFirstProductImage = (
  images: Shopify.ImageEdge[],
  product: Shopify.Product,
  productStage: ProductStage,
): Shopify.ImageEdge[] => {
  if (!isApparelProduct(product) || productStage === ProductStage.ComingSoon || productStage === ProductStage.Draft) {
    return images;
  }

  // Remove first image if is apparel type
  return images.slice(1);
};
